import React, { memo } from 'react';
import { Textarea } from '@/components/ui/textarea';
// import MonacoEditor from '@/components/ui/monaco-editor';
import { useSnapshot } from 'valtio';
import { sessionState } from '@/app/sessionState';
import { editorState } from './editor-state';
import { editor } from 'monaco-editor';

const DataPanel = memo(({ isDarkMode }) => {
  const { data } = useSnapshot(sessionState.demoData);

  return (
    <div className="h-full w-full flex flex-col">
      <div className="flex-1 relative">
        {/* <MonacoEditor
          value={data}
          onChange={(value) => sessionState.demoData.data = value}
          language="json"
          theme={isDarkMode ? "vs-dark" : "vs-light"}
          options={{
            tabSize: 2,
            minimap: { enabled: false },
            scrollbar: {
              vertical: 'auto',
              horizontal: 'auto',
              useShadows: true,
              verticalScrollbarSize: 10,
              horizontalScrollbarSize: 10
            },
            automaticLayout: true,
            scrollBeyondLastLine: false
          }}
          className="h-full mb-2"
        /> */}
        <Textarea
          value={data}
          onChange={(e) => {
            const newValue = e.target.value;            
            sessionState.demoData.data = newValue;
            editorState.demoData = newValue; // duplicate value: editorState.sampleData is used in prompt,  sessionState.demoData is used by APIRequest
            editorState.refresh();
          }}
          className="h-full mb-2 resize-none font-mono text-sm"
          placeholder="Enter JSON data..."
        />
      </div>
    </div>
  );
});

DataPanel.displayName = 'DataPanel';

export { DataPanel };